import PropTypes from 'prop-types';
import Styled from './product-filter-results-style';

/**
 * ProductFilterResult Component
 * Renders a list of products supplied by the filters, grouped by "main category"
 * @param {object} props - Component props
 * @param {Array} props.data - Array of product data
 * @param {Function} props.selectProduct - Array of product data
 * @returns {JSX.Element} ProductFilterResult component
 */
const ProductFilterResult = ({ data, selectProduct }) => (
  <Styled.Container>
    <Styled.ProductFilterGroup>
      {data?.length > 0 ? (
        data.map((product, idx) => (
          <Styled.ProductFilterGroupItemWrapper
            key={`${product.name}_${idx + 1}`}
            sm={6}
            md={4}
            lg={4}
            xl={3}
            xxl={3}
          >
            <Styled.ProductFilterGroupItem
              onClick={() => selectProduct(product)}
            >
              <Styled.ProductFilterGroupItemImage
                src={product.thumbnail}
                alt={product.name}
              />
              <Styled.ProductFilterGroupItemDescription>
                {product.main_category}
              </Styled.ProductFilterGroupItemDescription>
              <Styled.ProductFilterGroupItemTitle>
                <Styled.TitleItems>{product.name}</Styled.TitleItems>
              </Styled.ProductFilterGroupItemTitle>
            </Styled.ProductFilterGroupItem>
          </Styled.ProductFilterGroupItemWrapper>
        ))
      ) : (
        <Styled.ProductFilterGroupContainer>
          No products match the filters you have selected.
        </Styled.ProductFilterGroupContainer>
      )}
    </Styled.ProductFilterGroup>
  </Styled.Container>
);

ProductFilterResult.propTypes = {
  data: PropTypes.array.isRequired,
  selectProduct: PropTypes.func.isRequired,
};

export default ProductFilterResult;
